<!-- src/components/SettingFragment.vue -->
<template>
  <div class="settings-container">
    <mySetting></mySetting>
  </div>
</template>

<script>
import mySetting from "@/components/modules/mySettings.vue";

export default {
  components: {
    mySetting,
  },
  data() {
    return {
      openMenus: {}, // ✅ 별도의 객체로 메뉴 상태 관리
    };
  },
};
</script>

<style scoped>
  .settings-container {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background:var(--color-background);
    overflow-y: hidden;
    padding:0;
  }
</style>
